(() => {
  const selector = '.azul-product-page .product__title h1';
  const observers = new WeakMap();

  const fitTitle = (title) => {
    if (!title?.isConnected) return;

    title.style.removeProperty('font-size');
    const computed = window.getComputedStyle(title);

    if (computed.whiteSpace !== 'nowrap') return;

    const availableWidth = title.clientWidth;
    const maximumSize = Number.parseFloat(computed.fontSize);
    if (!availableWidth || !maximumSize) return;

    if (title.scrollWidth <= availableWidth + 1) return;

    let minimumSize = Math.min(32, maximumSize);
    let lower = minimumSize;
    let upper = maximumSize;

    for (let index = 0; index < 14; index += 1) {
      const candidate = (lower + upper) / 2;
      title.style.fontSize = `${candidate}px`;

      if (title.scrollWidth <= availableWidth + 1) {
        lower = candidate;
      } else {
        upper = candidate;
      }
    }

    title.style.fontSize = `${Math.max(minimumSize, lower - 0.25)}px`;
  };

  const initializeTitle = (title) => {
    if (observers.has(title)) return;

    let frame = 0;
    const scheduleFit = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => fitTitle(title));
    };

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleFit);
      observer.observe(title);
      if (title.parentElement) observer.observe(title.parentElement);
      observers.set(title, observer);
    } else {
      window.addEventListener('resize', scheduleFit, { passive: true });
      observers.set(title, true);
    }

    scheduleFit();
    if (document.fonts?.ready) {
      document.fonts.ready.then(scheduleFit).catch(() => {});
    }
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(selector).forEach(initializeTitle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
